export default "__VITE_ASSET__37bab376__"